module.exports = __webpack_public_path__ + "img/s32.444ef61a.jpg";